import React, { useEffect, useState, useRef } from "react";
import {
  Text,
  Divider,
  Img,
  Box,
  Flex,
  HStack,
  Stack,
  Button,
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import logo from "../../assets/images/sidebar_logo.svg";
import { Link, useLocation } from "react-router-dom";
import overview from "../../assets/icons/overview.svg";
import manufacturer from "../../assets/icons/manufacturer.svg";
import retailer from "../../assets/icons/retailer.svg";
import catalogue from "../../assets/icons/catalogue.svg";
import mapping from "../../assets/icons/mapping.svg";
import distributor from "../../assets/icons/distributor.svg";
import Subscrip from "../../assets/icons/image.png";
import Ads from "../../assets/icons/advertising.png";
import Image from "../../assets/icons/image.png";
import CouponLogo from "../../assets/icons/coupon.png";
import {
  LuPanelLeftOpen,
  LuPanelLeftClose,
  LuExternalLink,
} from "react-icons/lu";

const COLLAPSED_LABELS = {
  "Overview": "Overview",
  "Manufacturer List": "Manufacturer",
  "Distributor/ CNF List": "Distributor",
  "Retailer List": "Retailer",
  "Hospital List": "Hospital",
  "Product Catalogue": "Catalogue",
  "Mapping": "Mapping",
  "HSN Code": "HSN Code",
  "Subscriptions": "Subscriptions",
  "Subscribers": "Subscribers",
  "Coupons": "Coupons",
  "Ads": "Ads",
  "Affiliates": "Affiliates",
};

const menuItems = [
  {
    id: "1",
    label: "Overview",
    shortLabel: "Overview",
    path: "/overview",
    icon: overview,
  },
  {
    id: "2",
    label: "Manufacturer List",
    shortLabel: "Manufacturer",
    path: "/manufacturers",
    icon: manufacturer,
  },
  {
    id: "3",
    label: "Distributor/ CNF List",
    shortLabel: "Distributor",
    path: "/distributors",
    icon: distributor,
  },
  {
    id: "4",
    label: "Retailer List",
    shortLabel: "Retailer",
    path: "/retailers",
    icon: retailer,
  },
  {
    id: "5",
    label: "Hospital List",
    shortLabel: "Hospital",
    path: "/hospitals",
    icon: retailer,
  },
  {
    id: "6",
    label: "Product Catalogue",
    shortLabel: "Catalogue",
    path: "/product-catalogue",
    icon: catalogue,
  },
  {
    id: "7",
    label: "Mapping",
    shortLabel: "Mapping",
    path: "/mapping",
    icon: mapping,
  },
  {
    id: "8",
    label: "HSN Code",
    shortLabel: "HSN Code",
    path: "/hsn",
    icon: mapping,
  },
  {
    id: "9",
    label: "Subscriptions",
    shortLabel: "Subscriptions",
    path: "/Subscriptions-status",
    icon: Subscrip,
  },
  {
    id: "13",
    label: "Subscribers",
    shortLabel: "Subscribers",
    path: "/subscribers",
    icon: Image,
  },
  {
    id: "10",
    label: "Coupons",
    shortLabel: "Coupons",
    path: "/coupons",
    icon: CouponLogo,
  },
  {
    id: "11",
    label: "Ads",
    shortLabel: "Ads",
    path: "/ads-menu",
    icon: Ads,
  },
  {
    id: "12",
    label: "Affiliates",
    shortLabel: "Affiliates",
    path: "/affiliate",
    icon: Image,
  },
];

const LeftSidebar = () => {
  const [activepath, setActivePath] = useState("1");
  const [isPermanentExpanded, setIsPermanentExpanded] = useState(() => {
    const saved = localStorage.getItem("sidebar_collapsed");
    return saved !== null ? saved === "false" : false;
  });

  const location = useLocation();
  const sidebarRef = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const active = menuItems.find((item) => {
      if (item.path === "/overview") {
        return currentPath === "/overview" || currentPath === "/";
      }
      return currentPath.startsWith(item.path) || currentPath.includes(item.path);
    });
    setActivePath(active ? active.id : "1");
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isPermanentExpanded &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsPermanentExpanded(false);
        localStorage.setItem("sidebar_collapsed", "true");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPermanentExpanded]);

  const toggleSidebar = () => {
    setIsPermanentExpanded((prev) => {
      const next = !prev;
      localStorage.setItem("sidebar_collapsed", String(!next));
      return next;
    });
  };

  const displayExpanded = isPermanentExpanded;

  return (
    <Box
      ref={sidebarRef}
      as="aside"
      position="sticky"
      top="0"
      height="100vh"
      width="84px"
      minWidth="84px"
      maxWidth="84px"
      ml="-20px"
      flexShrink={0}
      zIndex={displayExpanded ? 1000 : 2}
    >
      <Box
        id="sidebar"
        bg="#F0F4F9"
        h="100vh"
        position={displayExpanded ? "absolute" : "relative"}
        top="0"
        left="0"
        w={displayExpanded ? "275px" : "84px"}
        display="flex"
        flexDir="column"
        borderRight="1px solid"
        borderColor="#E2E8F0"
        boxShadow={
          displayExpanded
            ? "4px 0 20px rgba(0, 0, 0, 0.08)"
            : "none"
        }
        transition="width 0.22s ease-in-out, box-shadow 0.22s ease-in-out"
        zIndex={1000}
        overflowY="auto"
        overflowX="hidden"
        css={{
          "&::-webkit-scrollbar": { width: "3px" },
          "&::-webkit-scrollbar-thumb": { background: "#CBD5E0", borderRadius: "3px" },
        }}
      >
        {/* Header */}
        {displayExpanded ? (
          <Box position="relative" pt="12px" pb="2px" px="16px" w="100%">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              w="100%"
            >
              <Link to="/overview">
                <Img
                  src={logo}
                  alt="JEE1"
                  h="52px"
                  maxW="145px"
                  objectFit="contain"
                  cursor="pointer"
                />
              </Link>
            </Box>
            <Box
              position="absolute"
              right="14px"
              top="calc(50% - 13px)"
              bg="white"
              w="26px"
              h="26px"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
              cursor="pointer"
              onClick={toggleSidebar}
              transition="background-color 0.15s ease"
              _hover={{ bg: "#F1F5F9" }}
              title="Collapse menu"
            >
              <Icon as={LuPanelLeftClose} color="#455fa4" fontSize="14px" />
            </Box>
            <Divider mt="12px" borderColor="gray.300" />
          </Box>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            pt="6px"
            pb="2px"
            w="100%"
          >
            <Link to="/overview">
              <Img
                src={logo}
                alt="JEE1"
                h="36px"
                maxW="62px"
                objectFit="contain"
                cursor="pointer"
              />
            </Link>
            <Box
              mt="3px"
              bg="white"
              w="25px"
              h="25px"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="0 1px 2px rgba(0, 0, 0, 0.08)"
              cursor="pointer"
              onClick={toggleSidebar}
              transition="background-color 0.15s ease"
              _hover={{ bg: "#F1F5F9" }}
              title="Expand menu"
            >
              <Icon as={LuPanelLeftOpen} color="#455fa4" fontSize="15px" />
            </Box>
            <Divider mt="4px" w="52px" borderColor="gray.300" />
          </Box>
        )}

        {/* Content */}
        <Box
          flex="1"
          minH="0"
          overflowY="auto"
          overflowX="hidden"
          w="100%"
          pt="4px"
          css={{
            "&::-webkit-scrollbar": { width: "3px" },
            "&::-webkit-scrollbar-thumb": { background: "#CBD5E0", borderRadius: "3px" },
          }}
        >
          {displayExpanded ? (
            <Stack spacing="5px" w="100%" px="10px" pb="16px">
              {menuItems.map((item, idx) => {
                const isActive = activepath === item.id;
                return (
                  <Link
                    key={idx}
                    to={item.path}
                    style={{ textDecoration: "none", width: "100%" }}
                  >
                    <Flex
                      h="35px"
                      minH="35px"
                      w="100%"
                      align="center"
                      px="12px"
                      cursor="pointer"
                      fontSize="xs"
                      fontWeight={isActive ? "600" : "normal"}
                      bg={isActive ? "#E4EBF4" : "transparent"}
                      _hover={{ bg: isActive ? "#E4EBF4" : "rgba(0,0,0,0.04)" }}
                      borderRadius="8px"
                      justifyContent="flex-start"
                      flexDir="row"
                      transition="background 0.15s"
                      position="relative"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mr="10px"
                        flexShrink={0}
                        w="20px"
                        h="20px"
                      >
                        <Img
                          src={item.icon}
                          alt={item.label}
                          maxW="20px"
                          maxH="20px"
                          objectFit="contain"
                        />
                      </Box>
                      <HStack flex="1" gap="2" minW="0">
                        <Text
                          fontSize="xs"
                          color={isActive ? "#1054C3" : "#334155"}
                          fontWeight={isActive ? "600" : "500"}
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {item.label}
                        </Text>
                      </HStack>
                      <Button
                        size="xs"
                        color="white"
                        bg="transparent"
                        p="2px"
                        minW="auto"
                        h="auto"
                        _hover={{ bg: "transparent", transform: "scale(1.1)" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          window.open(item.path, "_blank");
                        }}
                        title="Open in new tab"
                      >
                        <LuExternalLink color="#1134a6" size={14} />
                      </Button>
                    </Flex>
                  </Link>
                );
              })}
            </Stack>
          ) : (
            <Flex
              direction="column"
              alignItems="center"
              gap="1px"
              w="100%"
              pb="14px"
            >
              {menuItems.map((item, idx) => {
                const isActive = activepath === item.id;
                const itemContent = (
                  <Flex
                    w="74px"
                    py="3px"
                    px="4px"
                    align="center"
                    justify="center"
                    flexDir="column"
                    cursor="pointer"
                    fontSize="xs"
                    fontWeight={isActive ? "600" : "500"}
                    bg={isActive ? "#E4EBF4" : "transparent"}
                    _hover={{ bg: isActive ? "#E4EBF4" : "rgba(0,0,0,0.04)" }}
                    borderRadius="8px"
                    transition="all 0.15s ease"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      h="22px"
                      w="22px"
                    >
                      <Img
                        src={item.icon}
                        alt={item.label}
                        maxW="20px"
                        maxH="20px"
                        objectFit="contain"
                      />
                    </Box>
                    <Text
                      fontSize="10px"
                      letterSpacing="-0.2px"
                      mt="0px"
                      textAlign="center"
                      lineHeight="1.15"
                      color={isActive ? "#1054C3" : "#5F6D7E"}
                      fontWeight={isActive ? "600" : "500"}
                      whiteSpace="nowrap"
                      overflow="visible"
                    >
                      {COLLAPSED_LABELS[item.label] ?? item.shortLabel ?? item.label}
                    </Text>
                  </Flex>
                );

                return (
                  <Tooltip
                    key={idx}
                    label={item.label}
                    placement="right"
                    hasArrow
                    bg="gray.800"
                    color="white"
                    px="3"
                    py="2"
                    borderRadius="md"
                    openDelay={200}
                  >
                    <Link
                      to={item.path}
                      style={{
                        textDecoration: "none",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {itemContent}
                    </Link>
                  </Tooltip>
                );
              })}
            </Flex>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeftSidebar;
